/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerListSessionsQueryResponse, ResearchChatControllerListSessions400, ResearchChatControllerListSessions401, ResearchChatControllerListSessions404, ResearchChatControllerListSessions409, ResearchChatControllerListSessions500 } from "../types/ResearchChatControllerListSessions.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerListSessionsUrl() {
  const res = { method: 'GET', url: `/api/research-chat` as const }
  return res
}

/**
 * @description Returns all research chat sessions created by the current user.
 * @summary List user's chat sessions
 * {@link /api/research-chat}
 */
export async function researchChatControllerListSessions(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ResearchChatControllerListSessionsQueryResponse, ResponseErrorConfig<ResearchChatControllerListSessions400 | ResearchChatControllerListSessions401 | ResearchChatControllerListSessions404 | ResearchChatControllerListSessions409 | ResearchChatControllerListSessions500>, unknown>({ method : "GET", url : getResearchChatControllerListSessionsUrl().url.toString(), ... requestConfig })
  return res.data
}